import { AccountTyp, Identity } from '../types/identity';
/**
 * liefert das JWT-Payload als Objekt
 */
export function parseJwtPayload(jwt) {
  if (jwt != null) {
    const ajwt = jwt.split('.');
    if (ajwt.length === 3) {
      const payload = ajwt[1];
      const decodedJwt = atob(payload);
      return JSON.parse(decodedJwt);
    }
  }
  return null;
}
/**
 * gibt die Identität des JWT-Payloads aus.
 */
export function getIdentityFromJwt(jwtPayload) {
  return Object.values(Identity).find((value) => jwtPayload.groups.includes(`type.${value}`) ||
    jwtPayload.groups.includes(`${value}.hauptaccount`) ||
    jwtPayload.groups.includes(`${value}.subaccount`));
}
/**
 * gibt den Accounttyp (Hauptaccount oder Subaccount) des JWT-Payloads aus
 * im jwt2.4 gibt es die Unterscheidung des Accounttyps nur für Unternehmen, d.h. Privatpersonen und Partner haben nur einen Hauptaccount
 * zukünftig ist dies auch für z.B. eine Privatperson vorgesehen da in diesem Fall sog. Vertreter für den Kunden agieren können
 */
export function getAccountTypFromJwt(jwtPayload) {
  var _a;
  return (_a = Object.values(AccountTyp).find((value) => jwtPayload.groups.includes(`unternehmen.${value}`))) !== null && _a !== void 0 ? _a : AccountTyp.hauptaccount;
}
//# sourceMappingURL=jwt.util.js.map
